// extracted by mini-css-extract-plugin
export default {"pill":"ElapsedTimerPill_pill__lHzH0","dot":"ElapsedTimerPill_dot__UEOfH","time":"ElapsedTimerPill_time__qECdg"};